export default __webpack_public_path__ + "static/team@2x-78ec12befc2d1dd32179d3f94a1f2333.png";